const features = {
  TRUCK_STOP: 'truckstop',
  MEMBERSHIP_PRICING: 'membership_pricing',
  MEMBERSHIP_DISCOUNT: 'membership_discount',
  LOTTO: 'lotto',
  RESTAURANT: 'restaurant',
  CAR_WASH: 'carwash',
  PAY_AT_PUMP: 'pay_at_pump',
  WINE: 'wine',
  CASH_CREDIT: 'cash_credit',
  PAYPHONE: 'payphone',
  SERVICE_STATION: 'service_station',
  FULL_SERVICE: 'full_service',
  MEMBERSHIP_REQUIRED: 'membership_required',
  PROPANE: 'propane',
  C_STORE: 'c_store',
  BEER: 'beer',
  RESTROOMS: 'restrooms',
  ATM: 'atm',
  AIR: 'air',
};

const featureMappings = {
  location: [features.TRUCK_STOP, features.RESTAURANT, features.CAR_WASH, features.SERVICE_STATION, features.C_STORE, features.RESTROOMS],
  service: [features.LOTTO, features.WINE, features.PAYPHONE, features.PROPANE, features.BEER, features.ATM, features.AIR],
  fuel: [features.MEMBERSHIP_PRICING, features.MEMBERSHIP_DISCOUNT, features.PAY_AT_PUMP, features.CASH_CREDIT, features.FULL_SERVICE,
    features.MEMBERSHIP_REQUIRED],
};

const mapFeaturesToCategory = (featuresToMap) => {
  const mappedFeatures = Object.assign({}, featureMappings);

  Object.keys(mappedFeatures).forEach((mapCategory) => {
    mappedFeatures[mapCategory] = featuresToMap.filter(ftp => featureMappings[mapCategory].includes(ftp.id));
  });

  return mappedFeatures;
};

const supportedCountries = ['US', 'CA', 'AU'];

export { mapFeaturesToCategory, supportedCountries };
